import React from 'react'
import { TextComponent as Text } from '../custom-fdr-components'
import { useAppContext, Image } from '@ftdr/blueprint-components-react'
import { ButtonComponent as Button } from '../custom-fdr-components'
import { useSelector } from 'react-redux'
import { AppState } from 'src/store/initial-state'
import picture from '../../assets/img/washer-and-dryer.png'
import { generateDataByBrand } from 'src/utils/tenant-helper'

const DiscountBanner = () => {
  const bodyTextTemplateKey = generateDataByBrand([
    'DISCOUNT_BANNER_BODY_AHS',
    'DISCOUNT_BANNER_BODY_HSA',
    'DISCOUNT_BANNER_BODY_HBW210',
  ])

  const acceptedItemTypes = ['DRYER', 'WASHER']
  const { data } = useSelector((state: AppState) => state.replacement)
  const {
    appSettings: { localizedText },
  } = useAppContext()

  return data?.customer?.address?.state === 'GA' &&
    acceptedItemTypes.includes(data?.replacementDetails?.itemType || '') ? (
    <div className="appl-card w-full flex flex-wrap mb-6">
      <div className="w-full sm:w-4/6 px-6 py-6 3xl:pt-8 flex items-center 2xl:items-start sm:order-1 order-2">
        <div>
          <Text
            variant="heading-04"
            className="mb-4"
            textTemplateKey={localizedText('DISCOUNT_BANNER_HEADER')}
          />
          <Text
            className="mb-4"
            textTemplateKey={localizedText(bodyTextTemplateKey)}
          />
          <Button
            id="amazon-chat-external-button"
            size="small"
            variant="outlined"
            label={localizedText('DISCOUNT_BANNER_CTA')}
          />
        </div>
      </div>
      <div className="bg-pale-50 w-full sm:w-2/6 px-6 py-4 order-1 sm:order-2 flex items-center">
        <Image
          alt="banner"
          src={picture}
          objectPosition="leftTop"
          objectFit="contain"
          className="max-h-xs"
        />
      </div>
    </div>
  ) : null
}

export default DiscountBanner
